<template>
    <div class="select-of-airports">
        <template v-if="needMultipleSelect">
            <multiselect
                v-model="selectedTags"
                :placeholder="placeholder"
                :show-labels="false"
                label="text"
                track-by="value"
                :options="options"
                :multiple="true"
                :hide-selected="true"
                :searchable="internalSearch"
                :loading="loading"
                :disabled="disabled"
            >
                <span slot="noResult">Ничего не найдено. Попробуйте снова...</span>
            </multiselect>
        </template>
        <template v-else>
            <multiselect
                v-model="selectedPrepare"
                :placeholder="placeholder"
                :show-labels="false"
                label="text"
                track-by="value"
                :options="displayOptions"
                :hide-selected="true"
                :searchable="internalSearch"
                :loading="loading"
                :disabled="disabled"
                :taggable="allowCustomValue"
                tag-placeholder=""
                tag-position="bottom"
                @tag="onTag"
            >
                <span slot="noResult">Введите значение или выберите из списка</span>
            </multiselect>
        </template>
    </div>
</template>

<script>
import { API_AIRPORTS } from '@/constants';

/** Значение и текст варианта "Свой" - произвольный ввод, в выгрузку по ключу ничего не подтягивается */
const CUSTOM_OPTION = { value: '__custom__', text: 'Свой (ввести вручную)' };

export default {
    name: 'SelectOfAirports',
    props: {
        placeholder: { type: String, default: 'Начните вводить аэропорт' },
        index: { type: [String, Number], default: -1 },
        needNullElement: { type: Boolean, default: false },
        defaultSelectName: { type: String, default: 'Выберите аэропорт' },
        needMultipleSelect: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        selected: { type: [String, Number], default: null },
        selectedArray: { type: Array, default: () => [] },
        internalSearch: { type: Boolean, default: true },
        /** Фильтр по коду страны (CN, RU и т.д.) */
        countryCode: { type: String, default: '' },
        /** Разрешить произвольный ввод: при отсутствии в списке значение остаётся вписанным */
        allowCustomValue: { type: Boolean, default: false },
    },
    data() {
        return {
            options: [],
            selectedTags: [],
            selectedPrepare: null,
            loading: true,
        };
    },
    mounted() {
        this.loadAirports();
    },
    computed: {
        /** Варианты для отображения: при allowCustomValue первым идёт "Свой", плюс текущее значение, если его нет в списке */
        displayOptions() {
            if (!this.allowCustomValue || this.needMultipleSelect) return this.options;
            const val = this.selected;
            let list = [CUSTOM_OPTION, ...this.options];
            if (val !== null && val !== undefined && val !== '' && val !== CUSTOM_OPTION.value) {
                const has = this.options.some((o) => o.value === val);
                if (!has) list = [{ value: val, text: val }, ...list];
            }
            return list;
        },
    },
    watch: {
        selected: {
            handler() {
                if (!this.needMultipleSelect) this.prepareSelected();
            },
            immediate: false,
        },
        selectedTags(tags) {
            const values = tags.map((t) => t.value);
            this.$emit('set', this.needMultipleSelect ? values : values[0], null, this.index);
        },
        selectedPrepare(item) {
            if (item == null) return;
            const value = item.value === CUSTOM_OPTION.value ? '' : item.value;
            this.$emit('set', value, null, this.index);
        },
    },
    methods: {
        async loadAirports() {
            this.loading = true;
            try {
                let url = API_AIRPORTS;
                if (this.countryCode) {
                    url += `?country_code=${encodeURIComponent(this.countryCode)}`;
                }
                const { data } = await api.call('get', url);
                this.options = Array.isArray(data) ? data : [];
                if (this.needNullElement) {
                    this.options.unshift({ value: null, text: this.defaultSelectName });
                }
                if (this.needMultipleSelect) {
                    this.prepareTags();
                } else {
                    this.prepareSelected();
                }
            } finally {
                this.loading = false;
            }
        },
        prepareTags() {
            if (!Array.isArray(this.selectedArray)) return;
            this.selectedTags = this.options.filter((opt) => this.selectedArray.includes(opt.value));
        },
        prepareSelected() {
            const val = this.selected;
            if (val === null || val === undefined || val === '' || val === CUSTOM_OPTION.value) {
                if (this.allowCustomValue) {
                    this.selectedPrepare = CUSTOM_OPTION;
                } else {
                    this.selectedPrepare = this.needNullElement ? this.options[0] : null;
                }
                return;
            }
            const found = this.options.find((opt) => opt.value === val);
            if (found) {
                this.selectedPrepare = found;
                return;
            }
            if (this.allowCustomValue) {
                this.selectedPrepare = { value: val, text: val };
            } else {
                this.selectedPrepare = null;
            }
        },
        /** При taggable: пользователь ввёл произвольное значение */
        onTag(newVal) {
            this.$emit('set', newVal, null, this.index);
        },
    },
};
</script>

<style scoped>
.select-of-airports >>> .multiselect__input,
.select-of-airports >>> .multiselect__single,
.select-of-airports >>> .multiselect__placeholder,
.select-of-airports >>> .multiselect__option {
    font-size: 0.8125rem;
}
.select-of-airports >>> .multiselect__tags {
    min-height: 28px;
    padding: 4px 8px;
}
.select-of-airports >>> .multiselect__content-wrapper {
    max-height: 200px;
}
</style>
